import { useAuth0V2 } from "@stadium/services/auth0";
import { useStoreContext } from "@components/store/provider";
import useRouter from "@stadium/hooks/lib/use-custom-route";
import { useParams } from "next/navigation";

import { getOriginLoginParams } from "@stadium/services/auth/utils";

import { decodeMeta } from "@helpers/route";

import { LOGIN_CALLBACK_ROUTE, getGuestWorkspacePathFromStore } from "@constants/routes";

const emptyObj = {};

const AuthLogin = ({
  children,
  className = "",
  loginOptions = emptyObj,
  render,
  returnTo = "",
}) => {
  const { loginWithRedirect } = useAuth0V2();
  const { isNewRoute, storeCode } = useStoreContext();
  const { asPath } = useRouter();
  const { meta = "" } = useParams();
  const { origin } = decodeMeta(meta);

  const fallbackReturnTo = `${origin}${asPath}`;
  const returnToRoute = returnTo || fallbackReturnTo;

  const guestReturnTo = getGuestWorkspacePathFromStore({
    storeRoute: returnToRoute,
    isNewRoute,
    slug: storeCode ?? "",
  });

  const onClick = (params = {}) => {
    loginWithRedirect({
      redirectUri: window.location.origin + LOGIN_CALLBACK_ROUTE,
      appState: { returnTo: guestReturnTo },
      ...loginOptions,
      ...params,
      ...getOriginLoginParams(),
    });
  };

  if (render) return render({ handleOnClick: onClick });

  return (
    <div onClick={onClick} className={className}>
      {children}
    </div>
  );
};

export default AuthLogin;
